import { object } from 'prop-types';
import React from 'react';

import TextField from '../../FormFields/TextField';

const ChangeCountFields = ({
    errors,
    touched,
    values,
    ...props
}) => (
    <>
        <TextField
            autoComplete="off"
            errors={errors.ruleAggregateValue}
            label={`${process.env.isRuleAggregateChange ? 'Aggregate' : ''} Count`}
            name="ruleAggregateCount"
            required
            touched={touched.ruleAggregateCount}
            type="number"
            value={values.ruleAggregateCount}
            {...props}
        />
        <TextField
            autoComplete="off"
            errors={errors.ruleAggregateDuration}
            helperText={`Enter a value in ${process.env.isRuleAggregateChange ? 'minutes' : 'hours'}`}
            label="Duration"
            name="ruleAggregateDuration"
            required
            touched={touched.ruleAggregateDuration}
            type="number"
            value={values.ruleAggregateDuration}
            {...props}
        />
    </>
);

ChangeCountFields.defaultProps = {
    errors:  {},
    touched: {},
    values:  {}
};

ChangeCountFields.propTypes = {
    errors:  object,
    touched: object,
    values:  object
};

export default ChangeCountFields;
